import { useQuery } from '@apollo/client';

import clipsVideoAssetsQuery from 'bundles/clips/components/short-form-content/ClipsVideoAssets.graphql';

import type {
  ClipsVideoAssetsQuery,
  ClipsVideoAssetsQueryVariables,
} from '../components/short-form-content/__generated__/ClipsVideoAssets';

function useClipsVideoAssets({
  programSlug,
  courseId,
  itemId,
}: {
  programSlug?: string;
  courseId: string;
  itemId: string;
}) {
  return useQuery<ClipsVideoAssetsQuery, ClipsVideoAssetsQueryVariables>(clipsVideoAssetsQuery, {
    context: { clientName: 'gatewayGql' },
    fetchPolicy: 'cache-and-network',
    ssr: false,
    variables: {
      programSlug,
      courseId,
      itemId,
    },
  });
}

export default useClipsVideoAssets;
